import { FC } from "react";
import { Link as RouterLink } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import Translated from "../infrastructure/translation/Translated";
import styles from "./BackLink.module.css";

export const BackLink: FC<{ to: string }> = ({ to }) => (
  <RouterLink to={to} className={styles.backLink}>
    <FontAwesomeIcon icon={faChevronLeft} aria-hidden className={styles.icon} />
    <Translated textKey={"generic.back"} />
  </RouterLink>
);
